import React, { useState } from 'react';
import LocalizedMessage from 'react-l10n';
import Field from '../fields/Field';
import FieldAddress from '../fields/FieldAddress';
import FieldNumber from '../fields/FieldNumber';
import { getTranslation } from '../../lang/main';

/*
 * This is a work around to solve AddressLine 1 2 & 3 in Elvanti
 * AddressLine1 = StreetNumber
 * AddressLine2 = StreetName
 * AddressLine3 = StreetSuffix
 */
const FORM_LABEL = {
    FindAddress: getTranslation('FIELD.FIND_ADDRESS'),
    BusinessName: getTranslation('FIELD.REGISTERED_BUSINESS_NAME'),
    Phone: getTranslation('FIELD.PHONE'),
    StreetNumber: getTranslation('FIELD.ADDRESS_LINE_1'),
    StreetName: getTranslation('FIELD.ADDRESS_LINE_2'),
    StreetSuffix: getTranslation('FIELD.ADDRESS_LINE_3'),
    Suburb: getTranslation('FIELD.SUBURB'),
    State: getTranslation('FIELD.STATE'),
    PostalCode: getTranslation('FIELD.POSTCODE'),
    Country: getTranslation('FIELD.COUNTRY'),
};

function AddressFormFields(props) {
    const {
        formData,
        updateField,
        onFieldUpdate,
        defaultIsRequired,
        alwaysDisplayDetailedForm = false,
        showPhoneField = false,
    } = props;
    console.log('props', props);
    const [showDetailedFields, setShowDetailedFields] = useState(false);
    let { fieldRefs } = props;

    const onGoogleAddressFetch = (addressData) => {
        const {
            address,
            street_type,
            unit_number,
            street_number,
            street_number_2,
            street_name,
            suburb,
            postcode,
            state,
            country,
        } = addressData;

        if (addressData) {
            updateField('StreetNumber', unit_number);
            updateField('StreetName', address);
            updateField('Suburb', suburb);
            updateField('PostalCode', postcode);
            updateField('State', state);
            updateField('Country', country);
        }
        setShowDetailedFields(true);
    };

    const getRestrictedCountry = () => {
        const localeCountry = window.localeCountry || '';

        switch (localeCountry) {
            case 'Australia':
                return 'au';
            case 'Canada':
                return 'ca';
            case 'United States':
                return 'us';
            case 'South Africa':
                return 'za';
            case 'Botswana':
                return 'bw';
        }

        return '';
    };

    const onUpdatePhone = (e) => {
        const newValue = e.target.value;
        const isValid = /^[0-9]+$/.test(newValue); // Check if the value contains only digits

        if (isValid || newValue === '') {
            // Call onFieldUpdate only when the value is valid or empty
            onFieldUpdate(e);
        }
    };

    return (
        <React.Fragment>
            <div className='vspace vspace--small'>
                <FieldAddress
                    placeholder={getTranslation('FIELD.FIND_ADDRESS')}
                    label={FORM_LABEL['FindAddress']}
                    animatedLabel={FORM_LABEL['FindAddress']}
                    onAddressFetched={onGoogleAddressFetch}
                    name='RandomNameField'
                    autocompletionRequest={{
                        componentRestrictions: {
                            country: getRestrictedCountry(),
                        },
                    }}
                />
                {alwaysDisplayDetailedForm !== true && (
                    <div className='field-instruction'>
                        <a
                            className='button-link-plain'
                            onClick={(e) => setShowDetailedFields(true)}
                        >
                            <LocalizedMessage id={'ENTER_ADDRESS_MANUALLY'} />
                        </a>
                    </div>
                )}
            </div>

            {(showDetailedFields === true ||
                alwaysDisplayDetailedForm === true) && (
                <React.Fragment>
                        <Field
                            ref={(r) => (fieldRefs.BusinessName = r)}
                            label={FORM_LABEL['BusinessName']}
                            animatedLabel={FORM_LABEL['BusinessName']}
                            name='BusinessName'
                            value={formData.BusinessName || ''}
                            onChange={onFieldUpdate}
                            required={true}
                        />
                    {showPhoneField && (
                        <Field
                            required={true}
                            ref={(r) => (fieldRefs.Phone = r)}
                            label={FORM_LABEL['Phone']}
                            animatedLabel={FORM_LABEL['Phone']}
                            name='Phone'
                            value={formData.Phone || ''}
                            onChange={onUpdatePhone}
                        />
                    )}
                    <Field
                        ref={(r) => (fieldRefs.StreetNumber = r)}
                        label={FORM_LABEL['StreetNumber']}
                        animatedLabel={FORM_LABEL['StreetNumber']}
                        name='StreetNumber'
                        value={formData.StreetNumber || ''}
                        onChange={onFieldUpdate}
                    />
                    <Field
                        ref={(r) => (fieldRefs.StreetName = r)}
                        required={defaultIsRequired}
                        label={FORM_LABEL['StreetName']}
                        animatedLabel={FORM_LABEL['StreetName']}
                        name='StreetName'
                        value={formData.StreetName || ''}
                        onChange={onFieldUpdate}
                    />
                    {/*
                    <Field
                        ref={(r) => (fieldRefs.StreetSuffix = r)}
                        label={FORM_LABEL['StreetSuffix']}
                        animatedLabel={FORM_LABEL['StreetSuffix']}
                        name='StreetSuffix'
                        value={formData.StreetSuffix || ''}
                        onChange={onFieldUpdate}
                    />
                    */}
                    <div className='row row--small'>
                        <div className='col-xs-12 col-md-6'>
                            <Field
                                required={defaultIsRequired}
                                ref={(r) => (fieldRefs.Suburb = r)}
                                label={FORM_LABEL['Suburb']}
                                animatedLabel={FORM_LABEL['Suburb']}
                                name='Suburb'
                                value={formData.Suburb || ''}
                                onChange={onFieldUpdate}
                            />
                        </div>
                        <div className='col-xs-12 col-md-6'>
                            <Field
                                required={defaultIsRequired}
                                ref={(r) => (fieldRefs.State = r)}
                                label={FORM_LABEL['State']}
                                animatedLabel={FORM_LABEL['State']}
                                name='State'
                                value={formData.State || ''}
                                onChange={onFieldUpdate}
                            />
                        </div>
                    </div>
                    <div className='row row--small'>
                        <div className='col-xs-12 col-md-6'>
                            <Field
                                required={defaultIsRequired}
                                ref={(r) => (fieldRefs.PostalCode = r)}
                                label={FORM_LABEL['PostalCode']}
                                animatedLabel={FORM_LABEL['PostalCode']}
                                name='PostalCode'
                                value={formData.PostalCode || ''}
                                onChange={onFieldUpdate}
                            />
                        </div>
                        <div className='col-xs-12 col-md-6'>
                            <Field
                                disabled={true}
                                ref={(r) => (fieldRefs.Country = r)}
                                label={FORM_LABEL['Country']}
                                animatedLabel={FORM_LABEL['Country']}
                                name='Country'
                                value={formData.Country || window.localeCountry}
                                onChange={() => {}}
                            />
                        </div>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

// default props
AddressFormFields.defaultProps = {
    defaultIsRequired: false,
};

export default AddressFormFields;
